import {
    Button,
    IconButton as MuiIconButton,
    Modal as MuiModal,
    Typography,
    Box as MuiBox,
    styled,
} from "@mui/material"

import { CloseIcon as Close } from "@l2r-front/l2r-icons"

import { ScrollableLayout } from "../../layouts/ScrollableLayout"
import { styledForMobile } from "../../utils/styledForMobile"

export const Modal = styled(MuiModal, { shouldForwardProp: (prop) => prop !== "interactive" })(({ interactive }) => ({
    pointerEvents: interactive ? "auto" : "none",
}))

export const Box = styledForMobile(MuiBox)(({ height, width, theme, isMobile }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    borderRadius: !isMobile && theme.spacing(8),
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    height: isMobile ? "100%" : height,
    maxHeight: isMobile ? "100%" : "90%",
    justifyContent: "center",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: isMobile ? "100%" : width,
    maxWidth: isMobile ? "100%" : "80%",
    padding: isMobile ? theme.spacing(6) : theme.spacing(8),
    position: "absolute",
    margin: "auto",
}))

export const Title = styledForMobile(Typography)(() => ({
    textAlign: "left",
    flex: "1 1 auto",
}))

export const Desc = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(6),
}))

export const IconButton = styled(MuiIconButton)(() => ({
    padding: 0,
    height: 24,
    width: 24,
}))

export const CloseIcon = styled(Close)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    height: 24,
    width: 24,
}))

export const Header = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(8),
}))

export const TitleIcon = styled("div")(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    height: 28,
    width: 28,
    marginRight: theme.spacing(3),
}))

export const ButtonsContainer = styled("div")(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: isMobile ? "space-between" : "flex-end",
    gap: theme.spacing(6),
    marginTop: theme.spacing(8),
}))

export const BackButton = styled(Button)(({ theme }) => ({
    minWidth: "unset",
    width: "fit-content",
    textTransform: "initial",
    padding: 0,
    marginRight: theme.spacing(9),
}))

export const Content = styled("div")(() => ({
    display: "flex",
    flex: "1 1 auto",
    minHeight: 0,
}))

export const Layout = styled(ScrollableLayout)(() => ({
    height: "100%",
}))